import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ErrorHandler,
  importProvidersFrom,
  inject,
  LOCALE_ID,
  provideAppInitializer,
  provideZoneChangeDetection
} from '@angular/core';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
  withViewTransitions
} from '@angular/router';
import {
  provideMissingTranslationHandler,
  provideTranslateService
} from '@ngx-translate/core';
import { AuthHttpService } from '@shared/data';
import { MissingTranslationHelper, SentryErrorHandler } from '@shared/handlers';
import { authInterceptor } from '@shared/interceptors';
import { AppInitializeService, CheckForUpdateService } from '@shared/services';
import { getPreferredLanguage } from '@shared/utils';
import { en_GB, provideNzI18n } from 'ng-zorro-antd/i18n';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { translationHttpLoaderFactory } from '@shared/factories';
import { NzModalService } from 'ng-zorro-antd/modal';

bootstrapApplication(AppComponent, {
  providers: [
    CheckForUpdateService,
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideNzI18n(en_GB),
    importProvidersFrom(BrowserModule),
    NzModalService,
    provideTranslateService({
      missingTranslationHandler: provideMissingTranslationHandler(
        MissingTranslationHelper
      ),
      loader: translationHttpLoaderFactory()
    }),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled'
      }),
      withViewTransitions()
    ),
    AuthHttpService,
    provideHttpClient(withInterceptors([authInterceptor])),
    {
      provide: ErrorHandler,
      useClass: SentryErrorHandler
    },
    provideAppInitializer(() => inject(AppInitializeService).init()),
    {
      provide: LOCALE_ID,
      useFactory: getPreferredLanguage
    },
    provideAnimationsAsync()
  ]
}).catch(err => console.error('Angular Bootstrap Error:', err));
